import React, { ChangeEvent, useContext, useState } from "react";
import { convertTimetoString } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";
import Checkbox from "@mui/material/Checkbox";
import { NotAvailable } from "./styles";
import DocumentBar from "./DocumentBar";
import { JobHistoryDetails, RefereeData, CurrentEmployerDetails } from "./type";
import styles from "./css/styles.module.css";
import { ExNyRoute } from "../../../utils/allRouteId";
import apiCall from "../../../utils/apiCall";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from "../../../providers/notification";

interface WorkExperienceProps {
  routeId?: number;
  routeName?: string;
  workData?: JobHistoryDetails[];
  refreeData?: RefereeData[];
  referenceData?: RefereeData[];
  currentEmployerData?: CurrentEmployerDetails[];
  isReadOnly?: boolean;

}

interface Payload {
  id?: number;
  applicantId?: string;
  score: number;
}

const WorkExperience: React.FC<WorkExperienceProps> = ({
  routeId,
  routeName,
  workData = [],
  refreeData = [],
  referenceData = [],
  currentEmployerData = [],
}) => {
  const [id, setId] = useState<number | null>(null);
  const [score, setScore] = useState("");
  const [applicantId, setApplicantId] = useState<string | undefined>("");

  const { showNotification } = useContext(NotificationContext);
  const queryClient = useQueryClient();

  const [workScore, setWorkScore] = useState("");
// const normalizedRouteId = parseInt(String(routeId).trim(), 10);

const canUpdateWorkExperienceScore =
  routeName === "Examination/NYSC Route" || routeName === "Corporate Route";
  
  const handleScore = (event: ChangeEvent<HTMLInputElement>) => {
    setScore(event.target.value);
  };

  const handleCurrentEmployerDetails = (data?: CurrentEmployerDetails) => {
    setId(data?.Id ?? null);
    setApplicantId(data?.ApplicationId);
  };

  const handleWorkScore = (event: ChangeEvent<HTMLInputElement>) => {
    setWorkScore(event.target.value);
  };

  const handleWorkDetails = (data?: JobHistoryDetails) => {
    setWorkId(data?.Id);
    setWorkApplicantId(data?.ApplicationId);
  };

  const [workId, setWorkId] = useState<number | undefined>(undefined);
  const [workApplicantId, setWorkApplicantId] = useState<string | undefined>("");

  const url = `/Applicant/UpdateScorecurrentJobByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(score)}`;

  const updateEmploymentPromotionScore = async (payload: Payload) => {
    return await apiCall().post(url, payload);
  };

  const Url = `/Applicant/UpdateWorkExperienceByApplicantId?id=${workId}&applicantId=${workApplicantId}&score=${Number(workScore)}`;
  const updateWorkExperienceScore = async (payload: Payload) => {
    return await apiCall().post(Url, payload);
  };

  const updateEmploymentPromotionScoreMutation = useMutation(
    ["update-promotion-score"],
    updateEmploymentPromotionScore
  );

    const updateWorkExperienceScoreMutation = useMutation(
    ["update-work-score"],
    updateWorkExperienceScore
  );

  const updateEmploymentPromotionScoreHandler = async () => {
    const payload: Payload = {
      id: id ?? 0,
      applicantId,
      score: Number(score),
    };

    try {
      await updateEmploymentPromotionScoreMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "Employment promotion score has been successfully updated",
          });
          queryClient.refetchQueries([
            "get-all-workExperience-details",
            applicantId,
          ]);
          queryClient.refetchQueries(["get-all-personal-details"]);
          queryClient.refetchQueries(["get-approval"]);

          setScore("");
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };



    const updateWorkExperienceScoreHandler = async () => {
    const payload: Payload = {
      id: workId ?? 0,
      applicantId: workApplicantId,
      score: Number(workScore),
    };

  try {
    await updateWorkExperienceScoreMutation.mutateAsync(payload, {
      onSuccess: () => {
        showNotification({
          type: "success",
          message: "Work experience score updated successfully",
        });

        queryClient.refetchQueries([
          "get-all-workExperience-details",
          workApplicantId,
        ]);

        queryClient.refetchQueries(["get-all-personal-details"]);
        queryClient.refetchQueries(["get-approval"]);

        setWorkScore("");
      },
    });
  } catch (error: any) {
    showNotification({
      type: "error",
      message: error?.response?.data?.Message || error?.message,
    });
  }
};

  return (
    <div className={`${css.edDiv} ${css.workD}`}>
      <p className={css.title}>Work Experience(s)</p>
      <div className={styles.headingBar}>WORK EXPERIENCE</div>
      <div style={{ overflowX: "auto" }}>
        {workData &&
          workData &&
          workData?.length > 0 &&
        Array.isArray(workData) ? (
          <table>
            <tr className={styles.tableHead}>
              <th>Organization Name</th>
              <th>Position Held</th>
              <th>Current Job</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Organization Address</th>
              <th>Score</th>
            </tr>

            {workData?.map((wData: JobHistoryDetails, index: number) => (
              <tr key={wData.Id ?? index}>
                <td>{wData?.Organization || "N/A"}</td>
                <td>{wData?.PositionHeld || "N/A"}</td>
                <td
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginInlineStart: "-10px",
                  }}
                >
                  <label>
                    <Checkbox disabled checked={wData?.IsCurrentJob} />
                  </label>
                  <span style={{ color: "#666666" }}></span>
                </td>
                <td>{convertTimetoString(wData?.StartDate, 2) || "N/A"}</td>
                <td>
                  {wData?.IsCurrentJob
                    ? "-"
                    : convertTimetoString(wData?.EndDate, 2) || "N/A"}
                </td>
                <td>{wData?.CompanyAddress || "N/A"}</td>
          <td>
        <DocumentBar
          hideScoreIntegration={!canUpdateWorkExperienceScore}
          docName="Work Experience Document"
          documentUrl={wData?.UploadDocument}
          onChange={handleWorkScore}
          score={workScore}
          displayScore={wData?.Score}
          handleVisibility={() => handleWorkDetails(wData)}
          handleSubmit={updateWorkExperienceScoreHandler}
          loading={updateWorkExperienceScoreMutation?.isLoading}
        />
      </td>
              </tr>
            ))}
          </table>
        ) : (
          <NotAvailable>Not Available</NotAvailable>
        )}
      </div>

      {!(routeId == Number(ExNyRoute)) && (
        <>
          <div className={styles.headingBar}>
            CURRENT EMPLOYER INFORMATION(s)
          </div>
          <div style={{ overflowX: "auto" }}>
            {currentEmployerData.length > 0 ? (
              currentEmployerData.map((eData: CurrentEmployerDetails) => (
                <div key={eData?.ApplicationId} className={css.curEmpDet}>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Present Employer name
                    </span>
                    <br />
                    {eData?.PrensentEmployer || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Employer Address</span>
                    <br />
                    {eData?.EmployerAddress || "N/A"}
                  </div>
                  {eData?.Sector == "OTHERS" ? (
                    <div className={css.curEmpHeader1}>
                      <span className={css.curEmpHeader}>Sector</span>
                      <br />
                      {eData?.OtherSector || "N/A"}
                    </div>
                  ) : (
                    <div className={css.curEmpHeader1}>
                      <span className={css.curEmpHeader}>Sector</span>
                      <br />
                      {eData?.Sector || "N/A"}
                    </div>
                  )}
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Job Title</span>
                    <br />
                    {eData?.PresentDuty || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Grade Level</span>
                    <br />
                    {eData?.ApplicantGradeLevel === "Others"
                      ? eData?.OtherApplicantGradeLevel
                      : eData?.ApplicantGradeLevel}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Date of Appointment
                    </span>
                    <br />
                    {convertTimetoString(eData?.AppointmentDate, 2) || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>Total Employees</span>
                    <br />
                    {eData?.TotalNumberOfEmployees || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      No of Senior Employees
                    </span>
                    <br />
                    {eData?.NoOfSeniorEmployees || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      No of Junior Employees
                    </span>
                    <br />
                    {eData?.NoOfJuniorEmployees || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Last Year's Revenue/Turnover
                    </span>
                    <br />
                    {eData?.LastYearRevenue || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
                    <span className={css.curEmpHeader}>
                      Present Duties Scope
                    </span>
                    <br />
                    {eData?.PresentDuty || "N/A"}
                  </div>
                  <div className={css.curEmpHeader1}>
              <DocumentBar
                hideScoreIntegration={!canUpdateWorkExperienceScore}
                docName={`Evidence Of Promotion/Appointment`}
                documentUrl={eData?.UploadDocument}
                onChange={handleScore}
                score={score}
                displayScore={eData?.Score}
                handleVisibility={() => handleCurrentEmployerDetails(eData)}
                handleSubmit={updateEmploymentPromotionScoreHandler}
                loading={updateEmploymentPromotionScoreMutation?.isLoading}
              />
                  </div>
                </div>
              ))
            ) : (
              <NotAvailable>Not Available</NotAvailable>
            )}
          </div>

          <div className={styles.headingBar}>REFEREE</div>
          <div style={{ overflowX: "auto" }}>
            {refreeData?.length > 0 && routeId !== 4 && (
              <table>
                <tr className={styles.tableHead}>
                  <th className={css.curEmpHeader}>Full name</th>
                  <th className={css.curEmpHeader}>Email Address</th>
                  <th className={css.curEmpHeader}>Phone Number</th>
                  <th className={css.curEmpHeader}>Designation</th>
                  <th className={css.curEmpHeader}>Business Address</th>
                  <th className={css.curEmpHeader}>Uploaded Document</th>
                </tr>

                {refreeData?.length > 0 &&
                  refreeData?.map((eR: RefereeData, index: number) => (
                    <tr key={index}>
                      <td>{eR?.FullName || "N/A"}</td>
                      <td>{eR?.Email || "N/A"}</td>
                      <td>{eR?.PhoneNumber || "N/A"}</td>
                      <td>{eR?.Designation || "N/A"}</td>
                      <td>{eR?.BusinessAddress || "N/A"}</td>
                      <td>
                        <DocumentBar
                          hideScoreIntegration={false}
                          docName={`REFEREE DOCUMENT`}
                          documentUrl={eR?.RefereeLetterUrl}
                          onChange={() => {}}
                          handleSubmit={async () => {}}
                        />
                      </td>
                    </tr>
                  ))}
              </table>
            )}

            {referenceData?.length > 0 && routeId === 4 && <></>}

            {refreeData?.length === 0 && routeId !== 0 && (
              <NotAvailable>Not Available</NotAvailable>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WorkExperience;
